import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { SeoService } from 'src/app/services/seo.service';
import { RoutingService } from '../../services/routing.service';
import { RestapiService } from '../../services/restapi.service';
import { Map, tileLayer, marker, icon, circle } from 'leaflet';
import { MaprenderService } from '../../services/maprender.service';
@Component({
  selector: 'app-centros',
  templateUrl: './centros.component.html',
  styleUrls: ['./centros.component.scss']
})
export class CentrosComponent implements OnInit {

  private map: any;
  private center: any = [-16.5103641, -68.1291724];
  private mapObs: Subscription;

  url: string;
  cont: any;
  social: any;
  private routeObs: Subscription;
  constructor(
    private activatedRoute: ActivatedRoute,
    public mapRender: MaprenderService,
    public route: RoutingService,
    public api: RestapiService,
    public seo: SeoService
  ) {
    this.mapObs = this.mapRender.mapChanged.subscribe(res => {
      if (this.mapRender.mapCurrent === 'contact') {
        console.log('RENDER SINGLE MAP');
        setTimeout(() => {
          this.initMapSingle();
        }, 1000);
      }
    });
    this.routeObs = this.route.onRouteChange.subscribe(res => {
      console.log('routeObs change')
      setTimeout(() => {
        this.route.setCurrent(window.location.pathname);
        this.loadContent();
      }, 10);
    });
  }

  ngOnInit(): void {
    this.loadContent()
  }

  loadContent() {
    delete this.cont;
    this.url = this.activatedRoute.snapshot.paramMap.get('url');
    this.api.getdata('websection', {
      filters: { name: { value: this.url } }
    }).subscribe(res => {
      if (res.status == true) {
        console.log('CURRENT WEBSECTION', res);
        this.cont = res.result.data[0];
        this.social = {};
        this.cont.websectionosocial.forEach(el => {
          this.social[el.name] = el.link;
        });
        if(this.social.Latitud && this.social.Longitud){
          this.center = [this.social.Latitud, this.social.Longitud]
        }
        this.seo.generateTags({
          title:'WWF Educación Ambiental, '+this.cont.tagtitle,
          description: this.cont.tagdescription,
          image: this.api.route + this.cont.tagimage,
          slug: window.location.href,
        });
      }
      this.mapRender.mapRefresh('contact');
      console.log('social', this.social)
    })
    //this.initMapSingle();
  }

  initMapSingle(center?: any) {

    console.log('inicializa mapa')
    this.map = new Map('map').setView(center ? center : this.center , 15);
    tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.map);
    const customMarkerIcon = icon({
      iconUrl: '/assets/custom-marker-icon.png',
      iconSize: [40, 60],
      iconAnchor: [20, 60],
      popupAnchor: [0, 0]
    });
    marker(center ? center : this.center, { icon: customMarkerIcon })
      .bindPopup(`<p><b>Ubicación del centro</b></p>`, { autoClose: false })
      .addTo(this.map);
    /*  locations.forEach((location) => {
       marker([-68.1291724, -16.5103641], { icon: customMarkerIcon })
         .bindPopup(`<p><b>${location.name}</b></p>`, { autoClose: false })
         .addTo(this.map);
     }); */
  }
}
